import {ActiveJobsTypes} from '../ActionTypes/ActiveJobsTypes';

class ActiveJobsAction {
  static getActiveJobsList = payload => {
    return {
      type: ActiveJobsTypes.GET_ACTIVE_JOBS_LIST,
      payload: payload,
    };
  };

  static ClearActiveJobsList = () => {
    return {
      type: ActiveJobsTypes.CLEAR_ACTIVE_JOBS_LIST,
    };
  };
  static getCompletedJobsList = payload => {
    return {
      type: ActiveJobsTypes.GET_COMPLETED_JOBS_LIST,
      payload: payload,
    };
  };

  static ClearCompletedJobsList = () => {
    return {
      type: ActiveJobsTypes.CLEAR_COMPLETED_JOBS_LIST,
    };
  };
}

export default ActiveJobsAction;
